/**
 * TYPES
 */
import {_aggregates} from 'src/aggregates/index.d';
import * as Events from 'src/aggregates/tags/events.d';
import {types} from 'src/aggregates/tags/events.d';
import {IReducedGraphisTag} from 'src/aggregates/tags/handlers.d';


/**
 * CODE
 */

/**
 * I create a tags created event.
 *
 * :param id: created tag id
 * :param name: created tag name
 * :param company: created tag company
 *
 * :returns: tags created event
 */
function tagCreated (
    company: number,
    id: number,
    name: string,
    color: string,
): Events.ITagCreated
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_CREATED,
        _target: id,
        color,
        company,
        name,
        type: types.TAG_CREATED,
    };
}


/**
 * I create a tags creating event.
 *
 * :returns: tags creating event
 */
function tagCreating (): Events.ITagCreating
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_CREATING,
        _target: null,
        type: types.TAG_CREATING,
    };
}


/**
 * I create a tags loading event.
 *
 * :returns: tags loading event
 */
function tagLoading (): Events.ITagLoading
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_LOADING,
        _target: null,
        type: types.TAG_LOADING,
    };
}


/**
 * I create a tags loaded event.
 *
 * :returns: tags loaded event
 */
function tagLoaded (tags: IReducedGraphisTag[]): Events.ITagLoaded
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_LOADED,
        _target: null,
        tags,
        type: types.TAG_LOADED,
    };
}


/**
 * I create a tags not created event.
 *
 * :returns: tags not created event
 */
function tagNotCreated (): Events.ITagNotCreated
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_NOT_CREATED,
        _target: null,
        type: types.TAG_NOT_CREATED,
    };
}


/**
 * I create a tags not loaded event.
 *
 * :returns: tags not loaded event
 */
function tagNotLoaded (): Events.ITagNotLoaded
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_NOT_LOADED,
        _target: null,
        type: types.TAG_NOT_LOADED,
    };
}


/**
 * I create a tag not updated event.
 *
 * :returns: tag not updated event
 */
function tagNotUpdated (): Events.ITagNotUpdated
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_NOT_UPDATED,
        _target: null,
        type: types.TAG_NOT_UPDATED,
    };
}


/**
 * I create a tags reset error event.
 *
 * :returns: tags reset error event
 */
function tagsErrorReset (): Events.ITagsErrorReset
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAGS_ERROR_RESET,
        _target: null,
        type: types.TAGS_ERROR_RESET,
    };
}


/**
 * I create a tag updated event.
 *
 * :returns: tag not updated event
 */
function tagUpdated (tag: IReducedGraphisTag): Events.ITagUpdated
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_UPDATED,
        _target: tag.id,
        tag,
        type: types.TAG_UPDATED,
    };
}


/**
 * I create a tag updating event.
 *
 * :returns: tag updating event
 */
function tagUpdating (): Events.ITagUpdating
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: types.TAG_UPDATING,
        _target: null,
        type: types.TAG_UPDATING,
    };
}

/**
 * EXPORTS
 */
export {
    tagCreated,
    tagCreating,
    tagLoaded,
    tagLoading,
    tagNotCreated,
    tagNotLoaded,
    tagNotUpdated,
    tagsErrorReset,
    tagUpdated,
    tagUpdating,
};
